import { useRef } from 'react'
import cx from 'classnames'
import styles from './ActionSheet.module.css'

type ActionSetting = {
  text: string
  onClick: () => void
}

type ActionSheetProps = {
  actionList: ActionSetting[]
  onCancel: () => void
}

function ActionSheet(props: ActionSheetProps) {
  const { actionList, onCancel } = props
  const rootElementRef = useRef<HTMLDivElement>(null)

  return (
    <div
      ref={rootElementRef}
      className={styles.root}
      onClick={(e) => {
        if (e.target !== rootElementRef.current) return
        onCancel()
      }}
    >
      {Boolean(actionList.length) && (
        <div className={styles.buttonGroup}>
          {actionList.map((action, index) => (
            <button
              key={index}
              className={styles.button}
              onClick={() => {
                action.onClick()
              }}
            >
              {action.text}
            </button>
          ))}
        </div>
      )}
      <div className={styles.buttonGroup}>
        <button
          className={cx(styles.button, styles.cancelButton)}
          onClick={() => {
            onCancel()
          }}
        >
          取消
        </button>
      </div>
    </div>
  )
}

export default ActionSheet
